import intl from "react-intl-universal";

const PAGE_SIZE_OPTIONS = [10, 25, 50];

export const GridPagination = ({
  total,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  itemLabel,
  currentPageCount,
  totalPages: totalPagesOverride = undefined,
}) => {
  const resolvedCurrentPageCount = currentPageCount ?? 0;
  if (total === 0 || resolvedCurrentPageCount === 0) return null;

  const resolvedItemLabel = itemLabel ?? intl.get("common.operations");
  const end = (page - 1) * rowsPerPage + resolvedCurrentPageCount;
  const start = end - resolvedCurrentPageCount + 1;
  const displayTotal = Math.max(total, end);
  const totalPages = totalPagesOverride
    ?? Math.max(1, Math.ceil(displayTotal / rowsPerPage));

  return (
    <div className="flex flex-col gap-3 border-t border-gray-100 px-4 py-3 text-xs text-gray-500 dark:border-brand-dark-border dark:text-gray-400 sm:flex-row sm:items-center sm:justify-between">
      <p>
        {intl.get("common.showingRange", {
          start,
          end,
          total: displayTotal,
          itemLabel: resolvedItemLabel,
        })}
      </p>

      <div className="flex flex-wrap items-center gap-2 sm:gap-3">
        <label className="flex items-center gap-2">
          {intl.get("common.rowsPerPage")}
          <select
            value={rowsPerPage}
            onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
            className="baas-period-select !h-8 !py-1"
            aria-label={intl.get("common.rowsPerPage")}
          >
            {PAGE_SIZE_OPTIONS.map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </label>

        <div className="flex items-center gap-1">
          <button
            type="button"
            className="grid-history-action-btn grid-history-action-btn--icon !h-8 !w-8 !min-h-8 !min-w-8"
            disabled={page <= 1}
            onClick={() => onPageChange(1)}
            aria-label={intl.get("common.firstPage")}
          >
            «
          </button>
          <button
            type="button"
            className="grid-history-action-btn grid-history-action-btn--icon !h-8 !w-8 !min-h-8 !min-w-8"
            disabled={page <= 1}
            onClick={() => onPageChange(page - 1)}
            aria-label={intl.get("common.prevPage")}
          >
            ‹
          </button>
          <span className="min-w-[2rem] text-center font-semibold text-brand-dark dark:text-gray-100">
            {page}
          </span>
          <button
            type="button"
            className="grid-history-action-btn grid-history-action-btn--icon !h-8 !w-8 !min-h-8 !min-w-8"
            disabled={page >= totalPages}
            onClick={() => onPageChange(page + 1)}
            aria-label={intl.get("common.nextPage")}
          >
            ›
          </button>
          <button
            type="button"
            className="grid-history-action-btn grid-history-action-btn--icon !h-8 !w-8 !min-h-8 !min-w-8"
            disabled={page >= totalPages}
            onClick={() => onPageChange(totalPages)}
            aria-label={intl.get("common.lastPage")}
          >
            »
          </button>
        </div>
      </div>
    </div>
  );
};
